import Spare_wysiwygEditor from './wysiwygEditor';

export default {
  indexColumnHeader: [
    {
      id: 'name',
      textLabel: '標題',
      type: 'text-chip',
    },
    {
      id: 'owner',
      textLabel: '負責人',
      type: 'avatar',
    },
    {
      id: 'updatedAt',
      textLabel: '編輯時間',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
  ],
  indexFilterFieldTypes: [
    {
      name: 'search',
      type: 'search',
      title: '標題',
    },
    {
      name: 'factoryTags',
      type: 'one-layer-dropdown',
    },
    {
      name: 'owner',
      type: 'avatars',
      title: '負責人',
    },
    {
      name: 'duration',
      type: 'date-duration',
      title: '編輯時間',
      defaultValue: {
        start: '',
        end: '',
      }
    },
  ],
  contentTabs: [
    {
      id: 'meetingItemGroup',
      textLabel: '議案群組',
    },
    {
      id: 'exportRecord',
      textLabel: '匯出紀錄',
    },
  ],
  exportRecordColumnHeader: [
    {
      id: 'name',
      textLabel: '標題/檔名',
      type: 'text-chip',
    },
    {
      id: 'type',
      textLabel: '類型',
      type: 'text',
    },
    {
      id: 'createdUser',
      textLabel: '匯出者',
      type: 'avatar',
    },
    {
      id: 'createdAt',
      textLabel: '匯出時間',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'download',
      type: 'iconBtn',
      tabletHide: false,
      width: '50px',
    },
  ],
  exportRecordFilterFieldTypes: [
    {
      name: 'search',
      type: 'search',
      title: '標題',
    },
    {
      name: 'convertStatus',
      type: 'one-layer-dropdown',
      title: '狀態',
    },
    {
      name: 'meetingExportType',
      type: 'one-layer-dropdown',
      title: '類型',
    },
    {
      name: 'duration',
      type: 'date-duration',
      title: '匯出時間',
      defaultValue: {
        start: '',
        end: '',
      }
    },
    {
      name: 'createdUser',
      type: 'avatars',
      title: '匯出者',
    },
  ],
  downloadRecordColumnHeader: [
    {
      id: 'downloadAt',
      textLabel: '下載時間',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'downloadUser',
      textLabel: '下載人',
      type: 'avatar',
    },
  ],
  downloadRecordFilterFieldTypes: [
    {
      name: 'downloadAt',
      type: 'date-duration',
      title: '下載時間',
      defaultValue: {
        start: '',
        end: '',
      }
    },
    {
      name: 'downloadUser',
      type: 'avatars',
      title: '下載人',
    },
  ],
  meetingItemGroupBtnList: [
    {
      icon: 'icon-add',
      event: 'batchCreateMeetingItem',
      tooltipText: '新增議案'
    },
    {
      icon: 'icon-edit-pencil',
      event: 'updateMeetingItemGroup',
      tooltipText: '編輯'
    },
    {
      icon: 'icon-delete',
      event: 'deleteMeetingItemGroup',
      color: 'red',
      tooltipText: '刪除'
    }
  ],
  meetingItemBtnList: [
    {
      icon: 'icon-edit-pencil',
      event: 'updateMeetingItem',
      tooltipText: '編輯'
    },
    {
      icon: 'icon-delete',
      event: 'deleteMeetingItem',
      color: 'red',
      tooltipText: '刪除'
    },
  ],
  parseFailureSuggestions: {
    title: '解析失敗',
    list: [
      '檢查提案單跟提案單範本是否格式一致',
    ],
  },
  convertFailureSuggestions: {
    title: '轉檔失敗',
    list: [
      '檢查議程範本是否設定正確',
    ],
  },
  resolutionTemplateFailureSuggestions: {
    title: '解析失敗',
    list: [
      '檢查決議範本是否設定正確',
    ],
  },
  resolutionConvertFailureSuggestions: {
    title: '轉檔失敗',
    list: [
      '檢查決議範本是否設定正確',
    ],
  },
  exportFailureSuggestions: {
    title: '處理失敗',
    list: [
      '檢查附件是否含有加密保護或限制編輯權限',
    ],
  },
  attachLocationTypeRadioItems: {
    buttonItems: [
      {
        id: 0,
        value: 'item-attach-together',
        textLabel: '隨附於各議案後',
      },
      {
        id: 1,
        value: 'item-attach-seperate',
        textLabel: '集中於議程末尾',
      },
    ],
  },
  exportNameLocationRadioItems: {
    buttonItems: [
      {
        id: 'top-right',
        textLabel: '右上',
      },
      {
        id: 'top-left',
        textLabel: '左上',
      },
    ],
  },
  pageNumberRadioItems: {
    buttonItems: [
      {
        id: 'show',
        textLabel: '顯示',
      },
      {
        id: 'hide',
        textLabel: '不顯示',
      },
    ],
  },
  pageNumberLocationRadioItems: {
    buttonItems: [
      {
        id: 'bottom-left',
        textLabel: '左下',
      },
      {
        id: 'bottom-center',
        textLabel: '中下',
      },
      {
        id: 'bottom-right',
        textLabel: '右下',
      },
    ],
  },
  exportResolutionRadioItems: {
    buttonItems: [
      {
        id: 'yes',
        textLabel: '是',
      },
      {
        id: 'no',
        textLabel: '否',
      },
    ],
  },
  // 編輯決議的編輯器不開放字型選擇
  resolutionEditorButtons: Spare_wysiwygEditor.buttons.filter(button => button !== 'font'),
};
